import * as React from 'react'
import { FunctionComponent } from 'react'
import { Formik, useFormikContext } from 'formik'
import { DefaultButton } from '@fluentui/react'
import Form from '../../components/Form/Form'
import { IDefaultFolderDto } from '../../config/documentConfig'
import AddressField from '../../components/Field/Address/AddressField'
import { AddressDto } from '../../config/contactConfig'
import { FilePartyRoleDto } from '../../context/GlobalContext'

type FinanceDto = {
    rate: number
    termInvoice: number
    termPayment: number
    email: string
    ibanNumber: string
    vatNumber: string
    invoiceNumber: string
    invoiceMessage: string
}

type SettingsDto = {
    companyName: string
    displayName: string
    shortName: string
    cocNumber: string
    fileReference: string
    address: AddressDto
    finance: FinanceDto
    roles: FilePartyRoleDto[]
    folders: IDefaultFolderDto[]
}

const FormContainer: FunctionComponent = () => {
    const { values } = useFormikContext<SettingsDto>()

    return (
        <Form>
            <AddressField value={values.address} namespace={'address'} />
            {/*<TextField*/}
            {/*    label="Vestigingsplaats"*/}
            {/*    value={values.locality}*/}
            {/*    onChange={(_event: FormEvent, newValue?: string) => setFieldValue('locality', newValue)}*/}
            {/*/>*/}
            <DefaultButton primary text="Opslaan" type="submit" />
        </Form>
    )
}

const Implementation: FunctionComponent = () => {
    return (
        <Formik<SettingsDto>
            initialValues={{
                companyName: '',
                displayName: '',
                shortName: '',
                cocNumber: '',
                fileReference: '',
                address: {
                    street: '',
                    number: '',
                    postalCode: '',
                    locality: '',
                    country: 'NL',
                },
                finance: {
                    rate: 0,
                    termInvoice: 14,
                    termPayment: 14,
                    email: '',
                    ibanNumber: '',
                    vatNumber: '',
                    invoiceNumber: '',
                    invoiceMessage: '',
                },
                roles: [],
                folders: [],
            }}
            onSubmit={(values: SettingsDto) => console.log(values)}
        >
            <FormContainer />
        </Formik>
    )
}

export default Implementation
